<template>
  <span class="font-semibold pl-4">
    {{ text }}
  </span>
</template>

<script>
    export default {
    name: 'TicketBanner',
    props: {
        text: {
            type: String,
            required: true,
        },
    },
    }
</script>
